import Swiper from 'swiper/dist/js/swiper';
import Api from '../../base/script/api';
import InputCountry from '../../core/input/country/input-country';
import AnimationFade from '../../core/animation/fade/animation-fade';
import UtmData from '../../base/script/utmData';

import CardTempl from './card.pug';

export default {
  props: {
    cardinfo: Object,
    manager: Object,
    layoutText: {
      type: String,
      default: 'Планировка',
    },
    tourText: {
      type: String,
      default: '3D тур',
    },
    mapText: {
      type: String,
      default: 'Карта',
    },
    videoText: {
      type: String,
      default: 'Видео',
    },
  },
  template: CardTempl(),
  delimiters: ['${', '}}'],
  components: {
    AnimationFade,
    InputCountry,
  },
  data() {
    return {
      slider: {
        options: {
          slidesPerView: 1,
          resistance: true,
          resistanceRatio: 0,
          preloadImages: false,
          lazy: {
            loadPrevNext: false,
          },
          pagination: {
            bulletClass: 'card__slider-hover-el',
            bulletActiveClass: 'card__slider-hover-el--active',
            clickable: false,
            renderBullet(index, className) {
              return `<span class="${className}" style="width: calc(${100 / this.slides.length}% - 4px)"></span>`;
            },
          },
        },
        instance: undefined,
      },
      formComplete: false,
      showError: false,
      isOpened: false,
      formData: {
        type: '',
        phone: null,
      },
      sliderInited: false,
      showManager: false,
      // showManager: this.cardinfo.manager || false,
      showForm: false,
      cardInf: this.cardinfo.detail_url,
    };
  },
  computed: {
    slidersCut() {
      return this.cardinfo.slider.slice(0, 7);
    },
    hasChats() {
      return this.cardinfo.sectionData.manager.whatsapp || this.cardinfo.sectionData.manager.telegram || this.cardinfo.sectionData.manager.max;
    },
  },
  methods: {
    openForm(e) {
      this.showForm = true;
      this.formData.type = e ? e.srcElement.getAttribute('data-type') : 'call';
    },
    completeForm(phone) {
      this.formComplete = true;
      this.formData.phone = phone;
    },
    acceptForm(value) {
      this.formComplete = false;
      if (value.length === 0) {
        this.showError = false;
      }
    },
    formSubmit(e) {
      const form = e.srcElement;

      if (this.formComplete) {
        this.sendFunc(form);
      } else {
        this.showError = true;
      }
    },
    initSlider() {
      const slides = [].slice.call(this.card.querySelectorAll('.card__slide'));

      if (slides.length > 1) {
        this.slider.wrp = this.card.querySelector('.card__slider');
        this.slider.options.pagination.el = this.slider.wrp.querySelector('.card__slider-hover');
        this.sliderInited = true;
        this.$nextTick(() => {
          this.slider.instance = new Swiper(this.slider.wrp, this.slider.options);
          const sliderHovers = [].slice.call(this.slider.wrp.querySelectorAll('.card__slider-hover-el'));

          if (this.slider.instance !== undefined && this.slider.instance.initialized) {
            sliderHovers.forEach((hover, index) => {
              hover.addEventListener('mouseenter', () => {
                if (window.innerWidth >= 1280) {
                  this.slider.instance.slideTo(index);
                }
              });
            });
          }
        });
      }
    },
    cardClick() {
      if (this.cardinfo.detailUrl) {
        window.open(this.cardinfo.detailUrl, '_blank');
        return;
      }
      if (this.cardInf) {
        const data = {
          query: this.cardInf,
        };
        // eslint-disable-next-line
        Api.post(!IS_PROD ? './card.json' : '/landing/detailinfo', data).then((response) => {
          if (response.data && response.data.description) {
            this.cardinfo.sectionData.text.description = response.data.description;
          }
          if (response.data && response.data.layout_images) {
            if (!this.cardinfo.sectionData.slider.btns.find(c => c.id === `plan${this.cardinfo.id}`)) {
              this.cardinfo.sectionData.slider.btns.push({
                id: `plan${this.cardinfo.id}`,
                text: this.layoutText,
                name: this.cardinfo.id,
                slider: response.data.layout_images,
              });
            }
          }
          if (response.data && response.data.coords) {
            if (!this.cardinfo.sectionData.slider.btns.find(c => c.id === `map${this.cardinfo.id}`)) {
              this.cardinfo.sectionData.slider.btns.push({
                id: `map${this.cardinfo.id}`,
                text: this.mapText,
                name: this.cardinfo.id,
                map: {
                  center: {
                    coords: response.data.coords,
                    zoom: 16,
                    icon: '/icons/map-pin.svg',
                  },
                },
              });
            }
          }
          if (response.data && response.data.video) {
            if (!this.cardinfo.sectionData.slider.btns.find(c => c.id === `video${this.cardinfo.id}`)) {
              this.cardinfo.sectionData.slider.btns.push({
                id: `video${this.cardinfo.id}`,
                text: this.videoText,
                name: this.cardinfo.id,
                src: response.data.video,
              });
            }
          }
          if (response.data && response.data['3d_tour']) {
            if (!this.cardinfo.sectionData.slider.btns.find(c => c.id === `tour${this.cardinfo.id}`)) {
              this.cardinfo.sectionData.slider.btns.push({
                id: `tour${this.cardinfo.id}`,
                text: this.tourText,
                name: this.cardinfo.id,
                src: response.data['3d_tour'],
              });
            }
          }
          this.$emit('cardclick');
        });
      }
    },
    openFullPopup(data) {
      const popup = this.$el.querySelector('.popup-fullscreen');
      this.fullscreenCards = data.cards;
      this.activeCard = data.active;
      window.bodyLock.disableBodyScroll(popup);
      setTimeout(() => {
        this.popupFullOpen = true;
      }, 500);
    },
    managerButtonsClick(button, event) {
      if (button === 'max' && event) {
        event.stopPropagation();
      }
      if (button === 'chat' && event) {
        this.isOpened = true;
        event.stopPropagation();
      }
      if (button === 'whatsapp' && event) {
        event.stopPropagation();
      }
      if (button === 'telegram' && event) {
        event.stopPropagation();
      }
      if (button === 'phone' && event) {
        event.stopPropagation();

        if (window.innerWidth >= 768) {
          event.preventDefault();

          if (window.callbackPopup && window.callbackPopup.open) {
            window.callbackPopup.open();
          }
        }
      }
    },
  },
  mounted() {
    this.sendFunc = window.debounce((form) => {
      // if (window.Comagic) {
      //   this.formData.comagic = window.Comagic.getCredentials();
      // }
      new UtmData(this.formData);
      Api.post(form.action, this.formData)
        .then(() => {
          window.location.href = './success.html';
        });
    }, 300);
    this.card = this.$el;
    this.initSlider();
  },
};



// WEBPACK FOOTER //
// ./new-blocks/card/card.js